import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-signedout',
  templateUrl: './signedout.component.html',
  styleUrls: ['./signedout.component.scss'],
})
export class SignedoutComponent implements OnInit {

  constructor(private router: Router) { }

  public ngOnInit() {
  }

  public returnToApp() {
    this.router.navigate(['/']);
  }
}



// WEBPACK FOOTER //
// ./src/app/signedout/signedout.component.ts